import React from 'react';
import { Layers, TrendingUp, Workflow, HeartHandshake } from 'lucide-react';
import { ventureThesis } from '../../mock';
import { IMG, STOCK } from '../../lib/images';

const manifestoIcons = [Layers, TrendingUp, Workflow, HeartHandshake];

export default function Thesis() {
  return (
    <section id="thesis" className="relative bg-[#08080a] py-20 lg:py-28 border-t border-white/5 overflow-hidden">
      <div className="absolute top-1/2 right-0 w-[500px] h-[500px] rounded-full bg-[#d42b92]/10 blur-[150px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-end mb-12">
          <div className="reveal-up lg:col-span-7 max-w-3xl">
            <div className="text-[#ff8ec5] text-xs font-semibold tracking-[0.25em] uppercase mb-4">
              How We Build
            </div>
            <h2 className="font-semibold tracking-tight text-white text-3xl sm:text-4xl md:text-5xl leading-[1.06]">
              Build with intent.{' '}
              <span className="text-[#d42b92]">Scale with evidence.</span>
            </h2>
            <p className="mt-5 text-white/55 text-base sm:text-lg leading-relaxed max-w-2xl">
              We believe ventures should earn the right to scale.
            </p>
          </div>
          <div className="reveal-up lg:col-span-5 hidden md:block">
            <div className="group rounded-3xl overflow-hidden border border-white/10 aspect-[3/2] shadow-2xl">
              <img
                src={STOCK.thesis}
                alt="Google for Startups AI Day Jaipur - InnovHer"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {ventureThesis.manifesto.map((item, idx) => {
            const Icon = manifestoIcons[idx] || Layers;
            return (
              <div
                key={item.number}
                className="reveal-up group rounded-3xl border border-white/10 bg-white/[0.02] p-7 lg:p-8 hover:border-[#d42b92]/60 transition-colors"
                style={{ transitionDelay: `${idx * 60}ms` }}
              >
                <div className="flex items-center justify-between mb-5">
                  <span className="text-sm font-semibold tracking-[0.2em] text-[#d42b92]">
                    {item.number}
                  </span>
                  <span className="w-9 h-9 rounded-full bg-white/5 border border-white/10 grid place-items-center text-white/40 group-hover:border-[#d42b92]/50 transition-colors">
                    <Icon className="w-4 h-4" />
                  </span>
                </div>
                <h3 className="text-xl sm:text-2xl font-semibold text-white mb-3 tracking-tight">
                  {item.title}
                </h3>
                <p className="text-white/55 text-sm sm:text-base leading-relaxed">{item.text}</p>
              </div>
            );
          })}
        </div>

        <div className="reveal-up mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            '/new_images/12 (1).JPG',
            '/CODE/DSC03692.webp',
          ].map((src) => (
            <div
              key={src}
              className="rounded-2xl overflow-hidden border border-white/10 aspect-[16/10] bg-white/[0.02]"
            >
              <img src={src} alt="" className="w-full h-full object-cover" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
